<template>
       <div class="map-content">
           <div class="map-loader" v-if="loading">
                <i class="far fa-circle-notch fa-spin"></i> Chargement des marqueurs
            </div>
            <div class="map-filters">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <div class="col-sm-6">
                                <input type="range" min="0" max="1000" step="100" v-model="filters.range" class="slider" v-on:change="getData()" /> {{ filters.range }} km
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           <template>
                <div class="left-map-content">
                    <div class="left-content-map">
                    <l-map 
                        v-if="showMap"
                        :zoom="zoom"
                        :center="center"
                        :options="mapOptions"
                        ref="map"
                        style="height: 90%"
                        >
                        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                        <l-marker :lat-lng="markerLatLng"></l-marker>

                        <l-marker v-for="item in data" v-if="item.latitude != null && item.longitude != null"
                                  :key="item.id"
                                  :lat-lng="[item.latitude, item.longitude]">
                        </l-marker>
                    </l-map>
                    </div>
                </div>
           </template>
           <template>
                <div class="right-map-content" v-if="selectedData && selectedData != null"></div>
           </template>
    </div>
</template>

<script>


import { latLng,icon,Icon } from "leaflet";
import {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    LCircle,
    LRectangle,
    LPolygon,
    LPolyline,
    LIcon,
    LControl,
    LControlScale
} from "vue2-leaflet";

 delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
    name: "Map",
    components : {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LTooltip,
        LCircle,
        LRectangle,
        LPolygon,
        LPolyline,
        LControl,
        LIcon,
        LControlScale,
    },
    props: ['dataUrl'],
    data() {
        return {
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            zoom: 10,
            center: [51.505, -0.159],
            markerLatLng: [51.504, -0.159],
            mapOptions: {
                zoomSnap: 0.5
            },
            showMap: true,
            selectedData: null,
            data: [],
            loading: false,
            filters : {
                designation: null,
                range: 0,
            }
        }
    },
    methods: {
        zoomUpdate(zoom) {
            this.currentZoom = zoom;
        },
        centerUpdate(center) {
            this.currentCenter = center;
        },
        async getData(){
            this.loading = true;
             fetch(this.dataUrl + '?range=' + + this.filters.range + '&latitude='+ this.center[0] + '&longitude='+ this.center[1], {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders(),
                }).then((response) => {
                    if (response.status == 200) {
                        response.json().then((data) => {
                            if (data) {
                                this.data = data;
                            }
                        })
                        
                        this.loading = false;
                    }
                }).catch((error) => {
                    this.loading = false;
                });
        },
    },
    async mounted() {
        await this.getData();
    }
}
</script>

<style>
 

   

    .left-map-content {
        width: 100%;
        height: calc(100vh - 30vh);
    }
    .right-map-content {
        width: 650px;
        height: calc(100vh - 30vh);
        padding: 20px;
        background: white;
        position: absolute;
        top: 80px;
        right: 0px;
        z-index: 999;
    }

    .left-content-map {
        height: calc(100vh - 30vh); 
        width: 100%
    }



    @media screen and (max-width: 1000px) {
       .right-map-content {
           width: 100% !important;
       }

        
        .btn-type-action {
            display: flex;
            flex-direction: column;
            margin-right: -30px;
        }

        .btn-type-action .btn-icon {
            margin-bottom: 10px;
        }

        .btn-notify {
            margin-bottom: 60px;
        }

        .left-map-content {
            height: calc(100% - 55px);
            width: 100%;
            position:absolute;
            left: 0;
            top: 55px;
            left: 0;
            bottom: 0
        }

        .right-map-content {
            height: calc(100% - 55px);
            width: 100%;
            position:absolute;
            left: 0;
            top: 55px;
            left: 0;
            bottom: 0
        }

        .left-content-map {
            height: calc(100% - 55px);
            width: 100%;
            position:absolute;
            left: 0;
            top: 55px;
            left: 0;
            bottom: 0
        }

        .btn-type-action {
            margin-bottom: 30px !important;
        }
    }

    @media screen and (max-width: 500px) {
        .left-map-content {
            height: calc(100% - 55px);
            width: 100%;
            position:absolute;
            left: 0;
            top: 55px;
            left: 0;
            bottom: 0
        }

        .right-map-content {
            height: calc(100% - 55px);
            width: 100%;
            position:absolute;
            left: 0;
            top: 55px;
            left: 0;
            bottom: 0
        }

        .left-content-map {
            height: calc(100% - 55px);
            width: 100%;
            position:absolute;
            left: 0;
            top: 55px;
            left: 0;
            bottom: 0
        }
        .btn-type-action {
            margin-bottom: 30px !important;
        }
        .btn-notify {
            margin-bottom: 60px !important;
        }
    }

    @media screen and (max-width: 400px) {
        .left-map-content {
            height: calc(100% - 55px);
            width: 100%;
            position:absolute;
            left: 0;
            top: 55px;
            left: 0;
            bottom: 0
        }

        .right-map-content {
            height: calc(100% - 55px);
            width: 100%;
            position:absolute;
            left: 0;
            top: 55px;
            left: 0;
            bottom: 0
        }
        .btn-type-action {
            margin-bottom: 30px !important;
        }
        .btn-notify {
            margin-bottom: 60px !important;
        }

        .left-content-map {
            height: calc(100% - 55px);
            width: 100%;
            position:absolute;
            left: 0;
            top: 55px;
            left: 0;
            bottom: 0
        }
    }

    .actions-icon {
        display: flex;
    }
    .create-record-title {
        display: flex;
        justify-content: space-between;
    }
    .detail-title-record {
        display: flex;
        justify-content: space-between;
    }
    .record-icon {
        padding: 10px;
    }
    .record-icon:hover {
        cursor: pointer;
    }
    .btn-type-action {
        margin-bottom: 10px;
        padding: 10px;
    }
    .btn-notify {
        margin-bottom: 20px;
        padding: 10px;
    }
    .btn-icon {
        font-size: 30px !important;
    }
  



</style>